import { CalendarIllustration } from '../../../../assets/Illustrations/CalendarIllustration';
import { Typography } from '../Typography';

interface iEmptyListEventItemProps {
  type?: 'MyArea' | 'AprovaLive' | 'Tour';
}

function EmptyListEventItem({ type = 'MyArea' }: iEmptyListEventItemProps) {
  const message = {
    MyArea: 'Não existem eventos na sua agenda para esse dia',
    AprovaLive: 'Não existem eventos na agenda para esse dia',
    Tour: 'Não existem tours na agenda para esse dia',
  };

  return (
    <li className='flex flex-col items-center'>
      <Typography variant='italic' className='mt-7'>
        {message[type]}
      </Typography>
      <CalendarIllustration className='mx-8 mb-7 mt-5 h-60' />
    </li>
  );
}
export { EmptyListEventItem };
